import { QUERY_KEYS } from '@constants';
import { useMutation, useQueryClient } from 'react-query';
import { updateSlideSequence } from '@services';

export const useSlideSequenceMutation = () => {
    const queryClient = useQueryClient();
    const { userQuery, slideSequenceQuery } = QUERY_KEYS;

    return useMutation(sequenceData => updateSlideSequence(sequenceData), {
        onMutate: async data => {
            const { sequence: nextSequence, scenarioId } = data;
            const queryKey = [slideSequenceQuery, scenarioId];

            await queryClient.cancelQueries(queryKey);
   
            const previousSequence = queryClient.getQueryData(queryKey);

            queryClient.setQueryData(queryKey, nextSequence);

            return previousSequence;
        },
        onSettled: () => {
            queryClient.invalidateQueries(userQuery);
        },
        onError: (error, data, previousSequence) => {
             const { scenarioId } = data;

             queryClient.setQueryData([slideSequenceQuery, scenarioId], previousSequence);
        }
    });
};

